import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent {
  readonly navigationItems = [
    {
      relativeUrl: '/',
      label: 'title',
      icon: 'dashboard',
    },
  ];
}
